import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { ReactComponent as AlertTriangle } from "src/assets/static/images/alert-triangle.svg";
import { CLIENT_BLOGS, CLIENT_VACANCY } from "src/containers/layout";
function ErrorMessagePage() {
  const currentLocation = useLocation();
  const lang = useSelector((state) => state.common.lang);
  if (
    currentLocation?.pathname?.includes(CLIENT_BLOGS) ||
    currentLocation?.pathname?.includes(CLIENT_VACANCY)
  ) {
    return <div style={{ height: "500px" }}></div>;
  } else {
    return (
      <div className="error-module-page">
        <div className="error-in-modules-container">
          <div className="error-in-modules">
            <AlertTriangle />
            <div className="text-error-in-modules">
              {lang === "en"
                ? "We are sorry, chosen service is currently unavailable "
                : "ბოდიშს გიხდით, დროებით შეზღუდულია არჩეული სერვისით სარგებლობა"}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorMessagePage;
